import { combineReducers } from "redux";
import { actionTypes } from "../constants/actionTypes";
import { AllGamesReducer, AllPublicTournamentsReducer, UpdateEcReducer } from "./commonReducer";
import { tournamentDetailsReducer, updateScoreReducer } from "./tournamentRedcer";
import userReducer from "./userReducer";
import teamReducer from "../slices/teamSlice";

const appReducer = combineReducers({
  tournamentData: tournamentDetailsReducer,
  gameData: AllGamesReducer,
  publicTornamentData: AllPublicTournamentsReducer,
  updateScore: updateScoreReducer,
  UpdateEc: UpdateEcReducer,
  user: userReducer,
  team: teamReducer,
});

const rootReducer = (state, action) => {
  if (action.type === actionTypes.CLEAR_USER_DATA) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
